// Spanish string catalog (GDD §13.4). Every user-facing text lives here under a stable key; renaming or
// removing a key is an explicit change (es.keys.snap). Voice of the interface: expediente, impersonal, de
// usted; no emoji or decorative unicode (GDD §13.1). Character lines live under `voice.` (8 words at most).

const AVISO_TITLE = 'Obra de ficción y parodia';
const AVISO_DETAIL = 'Los personajes no representan a personas reales. No se avala ninguna actividad ilegal.';

export const es = {
  // Notice (AVISO) and title (TÍTULO) screens, GDD §13.2.
  'ui.aviso.label': 'Aviso',
  'ui.aviso.title': AVISO_TITLE,
  'ui.aviso.detail': AVISO_DETAIL,
  'ui.aviso.body': `${AVISO_TITLE}. ${AVISO_DETAIL}`,
  'ui.aviso.continue': 'Continuar',
  'ui.title.brand': 'Narcoverse',
  // Working title of the game (#18): changed in this single place.
  'ui.title.name': 'VUELO BLANCO',
  'ui.titulo.prompt': 'Pulse para despegar',
  'ui.titulo.badge': 'Versión preliminar · misiones pendientes de suministrar',

  // Tactical titles of the screens of GDD §13.2 (shells until each screen issue replaces them).
  'ui.screen.arranque': 'Cargando',
  'ui.screen.expedientes': 'Expedientes',
  'ui.screen.misiones': 'Misiones',
  'ui.screen.ajustes': 'Ajustes',
  'ui.screen.briefing': 'Briefing',
  'ui.screen.pausa': 'Pausa',
  'ui.screen.operacionFallida': 'Operación fallida',
  'ui.screen.recuento': 'Recuento',
  'ui.screen.cierre': 'Cierre',

  // CIERRE, the closing sequence and the credits (GDD §3.3, §13.2, issue #136). Parody names only (GDD §3.4).
  'ui.cierre.skip': 'Saltar',
  'ui.cierre.back': 'Volver al título',
  'ui.cierre.next': 'Siguiente',
  'ui.cierre.page': 'Página {n} de {max}',
  'ui.cierre.step.REVELACION': 'REVELACIÓN',
  'ui.cierre.step.ESCAPE': 'ESCAPE',
  'ui.cierre.step.HARINA': 'HARINA',
  'ui.cierre.step.CREDITOS': 'CRÉDITOS',
  'ui.cierre.speaker.narrator': 'Narrador',
  'ui.cierre.speaker.smith': 'Mr. Smith',
  'ui.cierre.speaker.morfi': 'Agente Morfi',
  'ui.cierre.speaker.turbina': 'Turbina',
  'ui.cierre.speaker.chiva': 'Doña Chiva',
  'ui.cierre.speaker.radio': 'La Radio',
  'ui.cierre.badge.dea': 'DEA',
  'ui.cierre.badge.agent': 'Agente Morfi',
  'ui.cierre.seal.flour': 'HARINA',
  'ui.cierre.caption.reveal': 'Mr. Smith era el Agente Morfi',
  'ui.cierre.caption.escape': 'Turbina se lanza en paracaídas con La Bolsa',
  'ui.cierre.caption.flour': 'La Bolsa sigue sellada: solo era harina',
  'ui.cierre.credits.title': 'CRÉDITOS',
  'ui.cierre.credits.audio': 'Audio',
  'ui.cierre.credits.fonts': 'Tipografías',
  'ui.cierre.credits.engine': 'Motor y herramientas',
  'ui.cierre.credits.design': 'Interfaz',
  'ui.cierre.credits.licence': 'Licencia',
  'ui.cierre.credits.teaser': 'EXPEDIENTE ABIERTO: CIUDAD JUÁREZ',
  'voice.closing.reveal.glasses': 'Se quita las gafas, despacio.',
  'voice.closing.reveal.morfi': 'Soy el Agente Morfi, de la DEA.',
  'voice.closing.escape.radio': 'Turbina vuelve a saltar en paracaídas.',
  'voice.closing.escape.turbina': 'Gracias por el viaje, Agente.',
  'voice.closing.flour.morfi': 'La bolsa solo tenía harina.',
  'voice.closing.flour.chiva': 'Y yo con tanta prisa.',

  // Slot screen (EXPEDIENTES), GDD §13.2 and §6.3.
  'ui.expedientes.empty': 'Sin expediente',
  'ui.expedientes.newGame': 'Nueva partida',
  'ui.expedientes.continue': 'Continuar',
  'ui.expedientes.delete': 'Eliminar',
  'ui.expedientes.lives': 'VIDAS {n}',
  'ui.expedientes.points': 'PUNTOS {n}',
  'ui.expedientes.delete.title': 'Eliminar expediente',
  'ui.expedientes.delete.body': 'Se borrará el expediente {slot}. Esta acción no se puede deshacer.',
  'ui.expedientes.delete.cancel': 'Cancelar',
  'ui.expedientes.delete.confirm': 'Eliminar',

  // Mission select (MISIONES), GDD §13.2 and §10.1.
  'ui.misiones.column.operation': 'OPERACIÓN',
  'ui.misiones.column.id': 'ID',
  'ui.misiones.column.threat': 'AMENAZA',
  'ui.misiones.column.status': 'ESTADO',
  'ui.misiones.status.locked': 'BLOQUEADA',
  'ui.misiones.status.available': 'DISPONIBLE',
  'ui.misiones.status.completed': 'COMPLETADA',
  'ui.misiones.threat.low': 'Baja',
  'ui.misiones.threat.medium': 'Media',
  'ui.misiones.threat.high': 'Alta',
  'ui.misiones.threat.critical': 'Crítica',
  'ui.misiones.nav.missions': 'MISIONES',
  'ui.misiones.nav.settings': 'AJUSTES',
  'ui.misiones.nav.credits': 'CRÉDITOS',
  'ui.misiones.assisted': 'ASISTIDO',
  'ui.misiones.world.1': 'MEDELLÍN',
  'ui.misiones.world.2': 'CALI',
  'ui.misiones.world.3': 'GUADALAJARA',
  'ui.misiones.world.4': 'SINALOA',
  'ui.misiones.world.completed': 'COMPLETADO',
  'ui.misiones.comingSoon': 'Próximamente',

  // Pause, briefing and level tally, GDD §13.2 and §13.5.
  'ui.pausa.title': 'PAUSA',
  'ui.pausa.open': 'Pausa',
  'ui.pausa.resume': 'Reanudar',
  'ui.pausa.restart': 'Reiniciar desde el checkpoint',
  'ui.pausa.settings': 'Ajustes',
  'ui.pausa.abandon': 'Abandonar misión',
  'ui.pausa.abandon.confirm': 'Se perderá lo avanzado desde el último checkpoint.',
  'ui.pausa.abandon.cancel': 'Cancelar',
  'ui.pausa.abandon.action': 'Abandonar',
  'ui.ajustes.back': 'Volver',
  'ui.ajustes.musicVolume': 'Volumen de música',
  'ui.ajustes.sfxVolume': 'Volumen de efectos',
  'ui.ajustes.reducedMotion': 'Movimiento reducido',
  'ui.ajustes.assistMode': 'Modo asistido',
  'ui.ajustes.assistMode.help': 'Avance al 80 %, huecos un 15 % más altos y 5 vidas. Se aplica al cargar el siguiente nivel.',
  'ui.ajustes.showFps': 'Mostrar FPS',
  'ui.briefing.title': 'Briefing',
  'ui.briefing.deploy': 'Desplegar',
  'ui.briefing.deploy.dialog': 'Confirmar despliegue',
  'ui.briefing.deploy.body': 'Se iniciará la operación {op}.',
  'ui.briefing.deploy.confirm': 'Confirmar',
  'ui.briefing.deploy.cancel': 'Cancelar',
  'ui.briefing.deploy.unavailable': 'Operación sin datos de vuelo.',
  'ui.briefing.back': 'Volver',
  'ui.briefing.route': 'RUTA',
  'ui.briefing.route.start': 'DESPEGUE',
  'ui.briefing.ending.airstrip': 'PISTA',
  'ui.briefing.ending.boss-and-jump': 'EL SALTO',
  'ui.briefing.threats': 'AMENAZAS CONOCIDAS',
  'ui.briefing.threats.none': 'Sin datos',
  'ui.briefing.message': 'MENSAJE',
  'ui.briefing.sender': 'Mr. Smith',
  'ui.briefing.resume': 'Reanudación: {checkpoint}',
  'ui.fallida.title': 'OPERACIÓN FALLIDA',
  'ui.fallida.body': 'Sin vidas. La misión se reinicia desde el despegue.',
  'ui.fallida.score': 'PUNTOS {score}',
  'ui.fallida.lives': 'VIDAS {lives}',
  'ui.fallida.retry': 'Reintentar',
  'ui.recuento.stamp.delivered': 'ENTREGADO',
  'ui.recuento.stamp.landed': 'ATERRIZADO',
  'ui.recuento.newRecord': 'NUEVA MARCA',
  'ui.recuento.assisted': 'ASISTIDO',
  'ui.recuento.line.columns': 'COLUMNAS',
  'ui.recuento.line.dollars': 'FAJOS',
  'ui.recuento.line.checkpoints': 'CHECKPOINTS',
  'ui.recuento.line.armor': 'BLINDAJE',
  'ui.recuento.line.decoys': 'SEÑUELOS',
  'ui.recuento.line.coins': 'MONEDAS',
  'ui.recuento.line.boss': 'JEFE',
  'ui.recuento.line.landing': 'ATERRIZAJE',
  'ui.recuento.line.jump': 'EL SALTO · {grade}',
  'ui.recuento.line.clean': 'VUELO LIMPIO',
  'ui.recuento.levelTotal': 'TOTAL NIVEL',
  'ui.recuento.runTotal': 'TOTAL PARTIDA',
  'ui.recuento.continue': 'Continuar',

  // HUD and notices.
  'ui.hud.intercept': 'INTERCEPT',
  'ui.hud.lives': 'VIDAS {lives}',
  'ui.hud.dollars': 'FAJOS {dollars}',
  'ui.hud.score': 'PUNTOS {score}',
  'ui.hud.badge.armor': 'BLINDAJE',
  'ui.hud.boss.label': 'Vida del jefe',
  'ui.hud.boss.value': '{hp} de {max}',
  'ui.hud.badge.bribe': 'SOBORNO {seconds} s',
  'ui.telemetry.label': 'Telemetría',
  'ui.telemetry.route': 'Telemetría de ruta',
  'ui.telemetry.active': 'Checkpoint activo',
  'ui.save.corrupt': 'Expediente dañado. Se ha creado una copia y se inicia uno nuevo.',
  'ui.save.unavailable': 'Guardado no disponible. El avance se perderá al cerrar.',
  'ui.view.rotate': 'Gire el dispositivo para ampliar la vista.',

  // Character voices: parody regional register, 8 words at most (GDD §13.4, open question §17-4).
  'voice.radio.checkpoint': 'Finca amiga a la vista',
  'voice.decoy.flour': '¡Es harina!',
  'voice.decoy.hidden': '¡Se escondió!',
  // Chepe Santacroche takes over the cranes of OP-201 (placeholder: the final text depends on §17-4, #21).
  'voice.chepe.cranes': 'Chepe: mis grúas, mis reglas',
  'voice.smith.2-1': 'Los Caballeros quieren el negocio de El Patrón.',
  'voice.smith.1-1': 'Amigo, entregue la Bolsa sellada. Sin excusas.',

  // In-game nicknames of the bosses (GDD §4.3, §9.2), shown on their health bar (#91).
  'boss.JEFE-1.name': 'El Patrón',
  'boss.JEFE-2.name': 'El Jinete',
  'boss.JEFE-3.name': 'El Padrinito',
  'boss.JEFE-4.name': 'El Chato',

  // Enemy names (GDD §8), shown with their ID in the BRIEFING threats.
  'enemy.EN-01.name': 'Gallinazo',

  // Text inside the 3D world; it lives here although it is not translated (GDD §11.1).
  'world.sign.usa': 'WELCOME TO THE USA',
  // El Salto (GDD §11.1, #94): the prompt of the jump zone, in display mono.
  'jump.prompt': 'SALTAR',

  // Missions (GDD §10).
  'mission.1-1.name': 'Comuna Despegue',
  'mission.1-2.name': 'La Hacienda',
  'mission.1-3.name': 'La Catedral',
  'mission.2-1.name': 'Puerto de Buenaventura',
  'mission.2-2.name': 'Cali Nocturna',
  'mission.2-3.name': 'Las Fincas',
  'mission.3-1.name': 'Rancho El Búfalo',
  'mission.3-2.name': 'Tequila Express',
  'mission.3-3.name': 'La Plaza',
  'mission.4-1.name': 'Sierra Madre',
  'mission.4-2.name': 'Culiacán',
  'mission.4-3.name': 'La Frontera',
} as const;

export type StringKey = keyof typeof es;

/** The text of a key; `{name}` placeholders are replaced from `params`. Keys are checked by TypeScript. */
export function t(key: StringKey, params: Readonly<Record<string, string | number>> = {}): string {
  return es[key].replace(/\{(\w+)\}/g, (placeholder, name: string) =>
    name in params ? String(params[name]) : placeholder,
  );
}
